import { Services } from "@/types/serviceTypes";
import { VariantServices } from "@/types/types";
import { MANDATORY_SERVICES } from "@/constants/constants.ts";

type Options = {
  mandatoryServicesOverride: string[];
};

export const mappedServices = (
  services: VariantServices,
  options: Options = { mandatoryServicesOverride: [] },
): Services => {
  if (!services) return [];

  const mandatoryServices = [
    ...MANDATORY_SERVICES,
    ...(options?.mandatoryServicesOverride || []),
  ];

  const addBlankLinkTargets = (html: string) => {
    const parser = new DOMParser();
    const document = parser.parseFromString(html, "text/html");
    const links = document.querySelectorAll("a");

    for (const link of links) {
      if (link.href && !link.target) link.setAttribute("target", "_blank");
    }

    return document.body.innerHTML;
  };

  return services
    .filter(
      (service) =>
        service.__typename === "DeliveryService" ||
        service.__typename === "ExtendedWarranty",
    )
    .map((service) => {
      const { __typename, title, id } = service;

      if (__typename === "ExtendedWarranty") {
        const {
          confirmation,
          policyDetail,
          purchaseDescription,
          tooltip,
          aliases: { skuId },
          price: { display, value },
          duration,
        } = service;

        return {
          id,
          title,
          display,
          duration,
          value: parseFloat(value),
          selected: false,
          skuId: skuId,
          tooltip: addBlankLinkTargets(tooltip),
          purchaseDescription,
          policyDetail: addBlankLinkTargets(policyDetail),
          confirmation: addBlankLinkTargets(confirmation),
          serviceType: "ExtendedWarranty",
          isMandatory: false,
        };
      }

      const {
        description,
        price: { display, value },
        aliases: { dmsId },
      } = service;

      return {
        id,
        title,
        description,
        display,
        value: parseFloat(value),
        selected: false,
        skuId: `DMS${dmsId}`,
        serviceType: "DeliveryService",
        isMandatory: mandatoryServices.includes(dmsId),
      };
    });
};
